import { render, staticRenderFns } from "./OrganizationMember.vue?vue&type=template&id=7ed33440"
import script from "./OrganizationMember.vue?vue&type=script&lang=js"
export * from "./OrganizationMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports